/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Close': {
    width: 12,
    height: 12,
    viewBox: '0 0 12 12',
    data: '<path pid="0" d="M.249.249a.85.85 0 011.202 0l10.253 10.253a.85.85 0 01-1.202 1.202L.249 1.451a.85.85 0 010-1.202z" _fill="#fff"/><path pid="1" d="M.251 11.704a.85.85 0 010-1.202L10.504.249a.85.85 0 011.202 1.202L1.453 11.704a.85.85 0 01-1.202 0z" _fill="#fff"/>'
  }
})
